import { IEnrolModel } from 'models/enrol.model'
import api from '../..'

export type CreateApplicationAttributes = Pick<
  IEnrolModel,
  | 'stateAdmin'
  | 'note'
  | 'userId'
  | 'courseId'
  | 'answerAdmin'
  | 'synchronousCourseEnrol'
>

const createApplication = (enrol: CreateApplicationAttributes) => {
  return api.post(`administration/applications`, { enrol })
}

export default createApplication
